import loginImage from "../Images/side img.svg";
import { TextField } from "@mui/material";
import eyeSlash from "../Images/eye-slash.svg";
import eye from "../Images/eye.svg";
import { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useHistory } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import googleIcon from "../Images/google icon.svg";
import Context from "../Contex/Context";
import { useContext } from "react";
import { useFormik } from "formik";
import { signupSchema } from "../Schemas/ChangePassword";
import { Helmet } from "react-helmet";
import companyLogo from "../../src/Images/coldemail_login.svg";
const label = { inputProps: { "aria-label": "Checkbox demo" } };
export default function SignUp() {
  const { setAuthenticate } = useContext(Context);
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);
  const [emailStatus, setEmailStatus] = useState({
    clicked: false,
    error: false,
  });
  const [userStatus, setUserStatus] = useState({
    clicked: false,
    error: false,
  });
  const [firstNameStatus, setFirstNameStatus] = useState({
    clicked: false,
    error: false,
    message: "",
  });
  const [lastNameStatus, setLastNameStatus] = useState({
    clicked: false,
    error: false,
  });
  const [passwordStatus, setPasswordStatus] = useState({
    clicked: false,
    error: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [apiStatus, setApiStatus] = useState({
    status: true,
  });
  const [checked, setChecked] = useState(true);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);

  function togglePassword() {
    setShowPassword(!showPassword);
  }
  function isValidEmail(email) {
    // Regular expression pattern for a valid email address
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return emailPattern.test(email);
  }
  const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_]).{8,}$/;
  function loginUser() {
    setSpinner(true);
    if (email.length === 0 || !isValidEmail(email)) {
      setEmailStatus({
        clicked: false,
        error: true,
      });
      setSpinner(false);
    } else if (firstName.length === 0) {
      setFirstNameStatus({
        clicked: false,
        error: true,
        message: "First name is required!",
      });
      setSpinner(false);
    } else if (lastName.length === 0) {
      setLastNameStatus({
        clicked: false,
        error: true,
        message: "Last name is required",
      });
      setSpinner(false);
    } else if (password.length === 0) {
      setPasswordStatus({
        clicked: false,
        error: true,
      });
      setSpinner(false);
    } else if (password.length < 8) {
      setPasswordStatus({
        clicked: false,
        error: true,
        message: "password should be more than 8 character",
      });
      setSpinner(false);
    } else if (!passwordRegex.test(password)) {
      setPasswordStatus({
        clicked: false,
        error: true,
        message: "password should contains 1 uppercase 1 alpha numeric",
      });
      setSpinner(false);
    } else {
      let data = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        password: password,
      };
      // console.log("form",data);
      axios
        .post(`${BaseUrl.baseurl}/email-marketing/user/register-user`, data)
        .then((res) => {
          setSpinner(false);
          setApiStatus(res.data);
          if (res.data.status) {
            history.push("/VerifyEmail", res.data.userId);
          }
        })
        .catch((err) => console.log("Error"));
    }
  }

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${response.access_token}` },
          }
        );
        console.log("userinfo", res.data);
        let data = {
          name: res.data.name,
          email: res.data.email,
        };
        axios
          .post(
            `${BaseUrl.baseurl}/email-marketing/user/register-login-user-gmail`,
            data
          )
          .then((res) => {
            setSpinner(false);
            setApiStatus(res.data);
            if (res.data.status) {
              localStorage.setItem(
                "MailSenderuserDetails",
                JSON.stringify(res.data)
              );
              setAuthenticate(true);
              history.push("/Email/accounts");
            }
          })
          .catch((err) => console.log("Error"));
      } catch (error) {
        console.log("error", error);
      }
    },
    onError: async (response) => {
      console.log("onError", response.error_description);
    },
  });
  function isTextOnly(inputString) {
    // Regular expression to match only alphabetical characters
    const textOnlyRegex = /^[a-zA-Z]+$/;

    // Test if the inputString matches the regular expression
    return textOnlyRegex.test(inputString);
  }

  const handleSignUp = (values, actions) => {
    setSpinner(true);
    let data = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.businessEmail,
      password: values.password,
    };
    axios
      .post(`${BaseUrl.baseurl}/email-marketing/user/register-user`, data)
      .then((res) => {
        setSpinner(false);
        setApiStatus(res.data);
        if (res.data.status) {
          history.push("/VerifyEmail", res.data.userId);
          actions.resetForm();
        }
      })
      .catch((err) => console.log("Error"));
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
    dirty,
    isValid,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      businessEmail: "",
      password: "",
    },
    validationSchema: signupSchema,
    onSubmit: handleSignUp,
  });

  const hasUpperCase = /[A-Z]/.test(values.password);
  const hasLowerCase = /[a-z]/.test(values.password);
  const hasNumber = /\d/.test(values.password);
  const specialCharacterRegex = /[!@#\$%\^&\*]/;
  const containsSpecialCharacter = specialCharacterRegex.test(values.password);
  const initialSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99935 1.33366C4.33268 1.33366 1.33268 4.33366 1.33268 8.00033C1.33268 11.667 4.33268 14.667 7.99935 14.667C11.666 14.667 14.666 11.667 14.666 8.00033C14.666 4.33366 11.666 1.33366 7.99935 1.33366Z"
        stroke="#868686"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 10.667V7.33366"
        stroke="#868686"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00391 5.33301H7.99792"
        stroke="#868686"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  const activeSvg = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99935 1.33366C4.33268 1.33366 1.33268 4.33366 1.33268 8.00033C1.33268 11.667 4.33268 14.667 7.99935 14.667C11.666 14.667 14.666 11.667 14.666 8.00033C14.666 4.33366 11.666 1.33366 7.99935 1.33366Z"
        stroke="#4BC25F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 8L6.5 10.5L11.5 6"
        stroke="#4BC25F"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  const errorSvg = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49996 1.33317C4.83329 1.33317 1.83329 4.33317 1.83329 7.99984C1.83329 11.6665 4.83329 14.6665 8.49996 14.6665C12.1666 14.6665 15.1666 11.6665 15.1666 7.99984C15.1666 4.33317 12.1666 1.33317 8.49996 1.33317Z"
        stroke="#FF3434"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 10.7321L8.4641 7.86603L11.4282 5"
        stroke="#FF3434"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.76795 5L8.63397 7.9641L11.5 10.9282"
        stroke="#FF3434"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  return (
    <div className="sign-parent-container md:grid md:grid-cols-2 md:gap-4">
      <Helmet>
        <title>
          ColdSender.com SignUp: Unlock Powerful Email Outreach Tools
        </title>
        <meta
          name="description"
          content="Sign up at ColdSender.com for seamless email outreach. Unlock powerful tools and elevate your communication stratergy. Join us today!"
        />
      </Helmet>
      <div className="hidden md:block">
        <img
          src={loginImage}
          alt=""
          style={{ width: "50vw", height: "100vh", objectFit: "cover" }}
        />
      </div>

      <div className="loginLayout">
        <div
          style={{
            padding: "6px 12px",
            display: "flex",
            flexDirection: "column",
            gap: "2px",
          }}
        >
          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "8px" }}
          >
            <img
              src={companyLogo}
              alt="rocket"
              style={{ height: "40px", marginBottom: "8px" }}
              loading="lazy"
            />
            
            <div className="social-btn">
              <button
                onClick={() => {
                  window.location.href = `${BaseUrl.baseurl}/email-marketing/user/redirect-google-registration`;
                }}
                type="button"
                style={{
                  width: "100%",
                  outline: "none",
                  backgroundColor: "#FFF",
                  padding: "6px 16px",
                  borderRadius: "4px",
                  color: "#434343",
                  fontSize: "16px",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow:
                    "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                }}
              >
                <img
                  src={googleIcon}
                  alt="Google Image"
                  style={{ height: "25px", width: "20px" }}
                  loading="lazy"
                />
                Sign Up with Google
              </button>
              <button
                onClick={() => {
                  window.location.href = `https://mail.coldsender.com/linkedin/get-linkedin-code`;
                }}
                type="button"
                style={{
                  width: "100%",
                  outline: "none",
                  backgroundColor: "#FFF",
                  padding: "6px 16px",
                  borderRadius: "4px",
                  color: "#434343",
                  fontSize: "16px",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow:
                    "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="25"
                  height="25"
                  viewBox="0 0 48 48"
                >
                  <path
                    fill="#0288D1"
                    d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                  ></path>
                  <path
                    fill="#FFF"
                    d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                  ></path>
                </svg>
                Sign Up with LinkedIn
              </button>
            </div>
            <p
              style={{
                color: "#4b4b4b",
                fontFamily: "Source Sans 3",
                fontSize: "28px",
                fontWeight: 700,
                fontStyle: "normal",
              }}
            >
              Signup
            </p>
            {!apiStatus.status && (
              <p className="emailpasswrong" style={{ marginTop: "0px" }}>
                {apiStatus.message}!
              </p>
            )}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  flexGrow: 1,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    // gap: "3px",
                  }}
                >
                  <label
                    htmlFor="firstname"
                    style={{
                      color: "#393939",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 400,
                      fontStyle: "normal",
                    }}
                  >
                    First Name
                  </label>
                  <div
                    style={{
                      border: `1px solid ${
                        errors.firstName && touched.firstName
                          ? "red"
                          : "#1C485F"
                      }`,
                      display: "flex",
                      gap: "6px",
                      backgroundColor: "#FAFAFA",
                      borderRadius: "4px",
                      padding: "0px 12px 0px 0px",
                      marginBottom: "3px",
                    }}
                  >
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.firstName}
                      placeholder="Enter your first name"
                      type="text"
                      id="firstname"
                      name="firstName"
                      autoComplete="off"
                      style={{
                        padding: "8px 4px 8px 12px",
                        backgroundColor: "#FAFAFA",
                        borderRadius: "4px",
                        outline: "none",
                        flexGrow: 1,
                      }}
                    />
                  </div>
                  {/* {errors.firstName && touched.firstName && (
                    <p style={{ color: "red",marginTop:'0px' }}>{errors.firstName}</p>
                    )} */}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    // gap: "3px",
                  }}
                >
                  <label
                    htmlFor="lastname"
                    style={{
                      color: "#393939",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 400,
                      fontStyle: "normal",
                    }}
                  >
                    Last Name
                  </label>
                  <div
                    style={{
                      display: "flex",
                      gap: "6px",
                      backgroundColor: "#FAFAFA",
                      border: `1px solid ${
                        errors.lastName && touched.lastName ? "red" : "#1C485F"
                      }`,
                      borderRadius: "4px",
                      padding: "0px 12px 0px 0px",
                      marginBottom: "3px",
                    }}
                  >
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastName}
                      placeholder="Enter your last name"
                      type="text"
                      id="lastName"
                      autoComplete="off"
                      style={{
                        padding: "8px 4px 8px 12px",
                        backgroundColor: "#FAFAFA",
                        borderRadius: "4px",
                        outline: "none",
                        flexGrow: 1,
                      }}
                    />
                  </div>
                  {/* {errors.lastName && touched.lastName && (
                    <p style={{ color: "red",marginTop:'0px' }}>{errors.lastName}</p>
                    )} */}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  // gap: "3px",
                }}
              >
                <label
                  htmlFor="business email address"
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  Business email address
                </label>
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    backgroundColor: "#FAFAFA",
                    border: `1px solid ${
                      errors.businessEmail && touched.businessEmail
                        ? "red"
                        : "#1C485F"
                    }`,
                    borderRadius: "4px",
                    padding: "0px 12px 0px 0px",
                    marginBottom: "3px",
                  }}
                >
                  <input
                    placeholder="Enter your business email address"
                    type="text"
                    autoComplete="off"
                    id="business email address"
                    name="businessEmail"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.businessEmail}
                    style={{
                      padding: "8px 4px 8px 12px",
                      backgroundColor: "#FAFAFA",
                      borderRadius: "4px",
                      outline: "none",
                      flexGrow: 1,
                    }}
                  />
                </div>
                {/* {errors.businessEmail && touched.businessEmail && (
                  <p style={{ color: "red",marginTop:'0px' }}>{errors.businessEmail}</p>
                  )} */}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  // gap: "3px",
                  position: "relative",
                }}
              >
                <label
                  htmlFor="newPassword"
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  Password
                </label>
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    backgroundColor: "#FAFAFA",
                    borderRadius: "4px",
                    border: `1px solid ${
                      errors.password && touched.password ? "red" : "#1C485F"
                    }`,
                    padding: "0px 12px 0px 0px",
                    marginBottom: "3px",
                  }}
                >
                  <input
                    placeholder="Enter your password"
                    type={`${showNewPassword ? "text" : "password"}`}
                    id="newPassword"
                    autoComplete="off"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    style={{
                      padding: "8px 4px 8px 12px",
                      backgroundColor: "#FAFAFA",
                      borderRadius: "4px",
                      outline: "none",
                      flexGrow: 1,
                    }}
                  />
                  <button
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    type="button"
                    style={{ outline: "none" }}
                  >
                    {!showNewPassword ? (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="vuesax/linear/eye">
                          <g id="eye">
                            <path
                              id="Vector"
                              d="M12.9833 9.99993C12.9833 11.6499 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.6499 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C11.6499 7.0166 12.9833 8.34993 12.9833 9.99993Z"
                              stroke="#868686"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              id="Vector_2"
                              d="M9.99987 16.8918C12.9415 16.8918 15.6832 15.1584 17.5915 12.1584C18.3415 10.9834 18.3415 9.00843 17.5915 7.83343C15.6832 4.83343 12.9415 3.1001 9.99987 3.1001C7.0582 3.1001 4.31654 4.83343 2.4082 7.83343C1.6582 9.00843 1.6582 10.9834 2.4082 12.1584C4.31654 15.1584 7.0582 16.8918 9.99987 16.8918Z"
                              stroke="#868686"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M12.1092 7.8916L7.89258 12.1083C7.35091 11.5666 7.01758 10.8249 7.01758 9.99993C7.01758 8.34993 8.35091 7.0166 10.0009 7.0166C10.8259 7.0166 11.5676 7.34994 12.1092 7.8916Z"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.8499 4.8084C13.3915 3.7084 11.7249 3.1084 9.99987 3.1084C7.0582 3.1084 4.31654 4.84173 2.4082 7.84173C1.6582 9.01673 1.6582 10.9917 2.4082 12.1667C3.06654 13.2001 3.8332 14.0917 4.66654 14.8084"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.01758 16.2751C7.96758 16.6751 8.97591 16.8917 10.0009 16.8917C12.9426 16.8917 15.6842 15.1584 17.5926 12.1584C18.3426 10.9834 18.3426 9.0084 17.5926 7.8334C17.3176 7.40006 17.0176 6.99173 16.7092 6.6084"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.9242 10.583C12.7076 11.758 11.7492 12.7163 10.5742 12.933"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.89102 12.1084L1.66602 18.3334"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.3324 1.66699L12.1074 7.89199"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                <span
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    color: "#5E5E5E",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  {values.password.length >= 8 && hasUpperCase && hasLowerCase
                    ? activeSvg
                    : values.password.length === 0
                    ? initialSvg
                    : errorSvg}
                  Include both lower and upper case characters , at least 8
                  characters
                </span>
                <span
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    color: "#5E5E5E",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  {hasNumber && (hasUpperCase || hasLowerCase)
                    ? activeSvg
                    : values.password.length === 0
                    ? initialSvg
                    : errorSvg}
                  Contains a number & Contains a letter
                </span>
                <span
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    color: "#5E5E5E",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  {containsSpecialCharacter
                    ? activeSvg
                    : values.password.length === 0
                    ? initialSvg
                    : errorSvg}
                  {`Contains a special character[!,@,#,$,%,^,&,*`}
                </span>
              </div>
              <div
                className="termsPolicy"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <Checkbox
                  {...label}
                  checked={checked}
                  onClick={() => {
                    setChecked(!checked);
                  }}
                  disableRipple
                  disableTouchRipple
                  sx={{
                    color: "#1C485F",
                    "&.Mui-checked": {
                      color: "#1C485F",
                    },
                  }}
                />
                <p
                  style={{
                    fontFamily: "Source Sans 3",
                    color: "#1a1a1a",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  I accept the{" "}
                  <b style={{ color: "#1C485F" }}>
                    <a
                      style={{
                        fontFamily: "Source Sans 3",
                        color: "#1a1a1a",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontStyle: "normal",
                      }}
                      href="https://coldsender.com/terms-and-conditions/"
                      target="_blank"
                    >
                      Terms and conditions
                    </a>
                  </b>{" "}
                  &{" "}
                  <a
                    style={{
                      fontFamily: "Source Sans 3",
                      color: "#1a1a1a",
                      fontSize: "14px",
                      fontWeight: 700,
                      fontStyle: "normal",
                    }}
                    href="https://coldsender.com/privacy-policy/"
                    target="_blank"
                  >
                    Privacy policy
                  </a>
                </p>
              </div>
            </div>
            <button
              type="submit"
              style={{
                textTransform: "none",
                background: "#1C485F",
                outline: "none",
                color: "#fff",
                padding: "10px 22px",
                fontSize: "16px",
                fontWeight: 400,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                // opacity: dirty && isValid ? 1 : 0.6,
                borderRadius: "5px",
              }}
            >
              {spinner && (
                <CircularProgress
                  style={{
                    color: "#FFF",
                    height: "15px",
                    width: "15px",
                  }}
                />
              )}
              Submit
            </button>
          </form>
          <div
            className="flex items-center flex-col gap-3"
            style={{ marginTop: "3px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <p
                style={{
                  fontFamily: "Source Sans 3",
                  color: "#1a1a1a",
                  fontSize: "14px",
                  fontWeight: 400,
                  fontStyle: "normal",
                }}
              >
                Already have an account?
              </p>
              <p
                style={{
                  color: "#3471b8",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  marginTop: "0px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  history.push("/Login");
                }}
              >
                Login now
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
